

































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { APP_CONFIG } from '@/config/app-config';

import { DepositModel } from '@/models/deposit';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailDeposit extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;

    // get rate() {
    //   return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    // }

    // get feeBuyOrigin() {
    //     return Math.round(this.order.feeBuy * (this.order.amountVND / 100));
    // }

    // get feeBuyDiscount() {
    //     return Math.round((this.feeBuyOrigin / 100) * (this.order.feeBuyDiscount || 0));
    // }

    // get feeWeightOrigin() {
    //     return (this.order.feeWeightAmount / (100 - this.order.feeWeightDiscount)) * 100;
    // }

    // get productsAmount() {
    //     return this.order.products.reduce((amount: number, prod: Product) => {
    //         return amount + (prod.quantity * (prod.pricePromotion || prod.priceOrigin));
    //     }, 0);
    // }

    get payment() {
        return this.deposit.payment > 0 ? formatNumber(this.deposit.payment, '0,0') + '' : '0';
    }

    // get needPayment() {
    //     return this.order.totalAmountVND - (this.order.deposit || 0);
    // }

    // private async created() {
    //     // if (!this.rate) {
    //     //     await this.getRate();
    //     // }
    // }

    // private async getRate() {
    //   const result = await commonService.exchangeRate();
    //   if (result && result.status === 200) {
    //     (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
    //   }
    // }
}
